import firebase from 'firebase/compat/app';
// import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyDZ4esZ2rMpLZIVFFxT_fHpxMS8ar9mHss',
  authDomain: 'otm-1-2618f.firebaseapp.com',
  projectId: 'otm-1-2618f',
  storageBucket: 'otm-1-2618f.appspot.com',
  messagingSenderId: '574859248178',
  appId: '1:574859248178:web:5b27682b481977fea2322b',
};

firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();

export default firebase;
